import React from "react";

const InputField = ({
  label,
  placeholder,
  type = "text",
  value,
  onChange,
  options = [],
}) => {

  // Textarea Field
  if (type === "textarea") {
    return (
      <div className="flex flex-col gap-2 w-full relative">
        <div className="flex gap-1">
        <label className="font-semibold text-xs leading-[18px] tracking-[2%]">
          {label}
        </label>
        <p className="text-red-600">*</p>
        </div>
        <textarea
          className="w-full h-[112px] px-4 py-3 rounded-2xl border-[1.5px] border-[#C7C7C7] text-sm outline-none placeholder:text-[#C7C7C7] resize-none"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
        <div className="absolute bottom-2 left-5 text-xs text-[#C7C7C7]">
          {value.length}/250
        </div>
      </div>
    );
  }

  // Select Field
  if(type === 'select'){
    return(
      <div className="flex flex-col gap-2 w-full relative">
        <div className="flex gap-1">
        <label className="font-semibold text-xs leading-[18px] tracking-[2%]">
          {label}
        </label>
        <p className="text-red-600">*</p>
        </div>
        <select
          className="appearance-none w-full  h-[56px] px-4 pr-10 py-3 rounded-2xl border-[1.5px] border-[#C7C7C7] text-sm outline-none"
          value={value}
          onChange={onChange}
        >
          <option disabled value=''className="text-[#00000066]" >
            {placeholder}
          </option>
          {options.map((opt, i) => (
            <option key={i} value={typeof opt === "string" ? opt : opt.State} >
              {typeof opt === "string" ? opt : opt.State}
            </option>
          ))}
        </select>
        <svg
          className="absolute right-4 top-2/3 -translate-y-1/2 pointer-events-none"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 8L10 12L14 8"
            stroke="#C7C7C7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    )
  }

  // Default field
  return (
    <div className="flex flex-col gap-2 w-full relative">
      <label className="font-semibold text-xs leading-[18px] tracking-[2%]">
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        className="w-full h-[56px] px-4 py-3 rounded-2xl border-[1.5px] border-[#C7C7C7] text-sm outline-none"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
export default InputField;


